import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import AppNavLink from '../../../AppNavLink';
import * as Icons from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { Colors } from 'shared/constants/AppEnums';
import { alpha, Icon, ListItem, ListItemText } from '@mui/material';
import { useSidebarContext } from '../../../../utility/AppContextProvider/SidebarContextProvider';
function HorizontalItem({ item, dense }) {
  const location = useLocation()

  const { sidebarMenuSelectedTextColor } = useSidebarContext()

  const active = isUrlInChildren(item, location.pathname)

  function isUrlInChildren(parent, url) {
    if (!parent.children) {
      return false;
    }

    for (let i = 0; i < parent.children.length; i++) {
      if (parent.children[i].children) {
        if (isUrlInChildren(parent.children[i], url)) {
          return true;
        }
      }

      if (
        parent.children[i].url === url ||
        url.includes(parent.children[i].url)
      ) {
        return true;
      }
    }

    return false;
  }

  const handleClick = () => {
    if (item.isNewWindow === '1') {
      window.open(item.url)
    }
  }

  const IconComponent = Icons[item?.icon];

  return (
    item?.isNewWindow !== '1' ? (
      <ListItem
        {...item}
        exact={item.exact}
        component={AppNavLink}
        onClick={() => handleClick()}
        to={item?.isNewWindow !== '1' ? item.url : ''}
        className={clsx('navItemSubmenu', dense && 'dense')}
        activeClassName={item.isNewWindow === '1' || item.isAction === '1' ? '' : 'active'}
        sx={{
          minHeight: 40,
          padding: '4px 12px',
          color: (theme) => theme.palette.text.primary,
          textDecoration: 'none!important',
          minWidth: 160,
          '&.active': {
            color: Colors.primary,
            backgroundColor: alpha(Colors.primary, 0.1),
            pointerEvents: 'none',
            '& .list-item-text-primary': {
              color: 'inherit',
            },
            '& .list-item-icon': {
              color: 'inherit',
            },
          },
          '& .list-item-text': {
            padding: '0 0 0 16px',
          },
          '&.dense': {
            padding: '4px 12px',
            minHeight: 40,
            '& .list-item-text': {
              padding: '0 0 0 8px',
            },
          },
        }}
      >
        {/* {item.icon && (
        <Icon
          sx={{
            color: active ? sidebarMenuSelectedTextColor : 'action',
            mr: 3,
            fontSize: { xs: 16, xl: 18 },
          }}
        >
          <IconComponent sx={{ fontSize: '20px' }} />
        </Icon>
      )} */}
        <ListItemText
          className='AppNavLinkTextSubmenu'
          primary={item.messageId || item?.message_id}
        />
        {item.count && (
          <Box ml={4}>
            <Badge
              count={item.count}
              sx={{
                color: item.color,
              }}
            />
          </Box>
        )}
      </ListItem>
    ) : (
      <ListItem
        {...item}
        exact={item.exact}
        component={'a'}
        target="_blank"
        href={item?.url}
        rel="noopener noreferrer"
        className={clsx('navItemSubmenu', dense && 'dense')}
        activeClassName={item.isNewWindow === '1' || item.isAction === '1' ? '' : 'active'}
        sx={{
          minHeight: 40,
          padding: '4px 12px',
          color: (theme) => theme.palette.text.primary,
          textDecoration: 'none!important',
          minWidth: 160,
          '&.active': {
            color: Colors.primary,
            backgroundColor: alpha(Colors.primary, 0.1),
            pointerEvents: 'none',
            '& .list-item-text-primary': {
              color: 'inherit',
            },
            '& .list-item-icon': {
              color: 'inherit',
            },
          },
          '& .list-item-text': {
            padding: '0 0 0 16px',
          },
          '&.dense': {
            padding: '4px 12px',
            minHeight: 40,
            '& .list-item-text': {
              padding: '0 0 0 8px',
            },
          },
        }}
      >
        <ListItemText
          className='AppNavLinkTextSubmenu'
          primary={item.messageId || item?.message_id}
        />
        {item.count && (
          <Box ml={4}>
            <Badge
              count={item.count}
              sx={{
                color: item.color,
              }}
            />
          </Box>
        )}
      </ListItem>
    )
  );
}

HorizontalItem.defaultProps = {};

export default React.memo(HorizontalItem);

HorizontalItem.propTypes = {
  item: PropTypes.object,
  location: PropTypes.object,
  dense: PropTypes.bool,
};
